/**
 * Compiled values of `@wordpress/base-styles` design tokens, for use in
 * CSS strings injected into the editor canvas iframe where Sass is not
 * available.
 *
 * Keep in sync with `@wordpress/base-styles`.
 */

// _variables.scss — $elevation-x-small
export const ELEVATION_X_SMALL =
	'0 1px 1px rgba(0, 0, 0, 0.03), 0 1px 2px rgba(0, 0, 0, 0.02), 0 3px 3px rgba(0, 0, 0, 0.02), 0 4px 4px rgba(0, 0, 0, 0.01)';

// _variables.scss — $radius-full
export const RADIUS_FULL = '9999px';

// _variables.scss — $button-size-compact
export const BUTTON_SIZE_COMPACT = '32px';

// _variables.scss — $button-size-small
export const BUTTON_SIZE_SMALL = '24px';

// _variables.scss — $grid-unit-05
export const GRID_UNIT_05 = '4px';

// _variables.scss — $grid-unit-10
export const GRID_UNIT_10 = '8px';

// _variables.scss — $border-width
export const BORDER_WIDTH = '1px';

// _variables.scss — $border-width-focus-fallback
export const BORDER_WIDTH_FOCUS_FALLBACK = '2px';

// _colors.scss — $white
export const WHITE = '#fff';

// _font.scss — $font-size-x-small
export const FONT_SIZE_X_SMALL = '11px';

// _font.scss — $font-size-medium
export const FONT_SIZE_MEDIUM = '13px';

// @wordpress/theme — --wpds-typography-font-weight-emphasis
export const FONT_WEIGHT_EMPHASIS =
	'var(--wpds-typography-font-weight-emphasis, 600)';

// _font.scss — $font-line-height-small
export const FONT_LINE_HEIGHT_SMALL = '20px';
